<template>
  <div class="contacts-list">
    <ul>
      <li
        v-for="contact in sortedContacts"
        :key="contact.depanneur_id"
        @click="selectContact(contact)"
        :class="{ selected: contact == selected }"
      >
        <div class="avatar">
          <img
            :src="`${apiDomain}/uploads/files_user/${contact.photo}`"
            style="width: 100%"
          />
        </div>
        <div class="contact">
          <p class="name">
            {{ contact.nom.charAt(0).toUpperCase() + contact.nom.slice(1) }}
          </p>
          <p class="email">
            Je suis
            <span v-if="contact.pro.Serrurier == 1">Serrurier, </span>
            <span v-if="contact.pro.Plombier == 1">Plombier,</span>
            <span v-if="contact.pro.Electricien == 1">Electricien,</span>
            <span v-if="contact.pro.Vitrier == 1">Vitrier</span>
          </p>
        </div>
        <span class="unread" v-if="contact.unread">{{ contact.unread }}</span>
      </li>

      <CCard accent-color="danger" v-if="contacts.length == 0">
        <CCardHeader
          ><B>
            <p>
              Vous n'avez pas des contacts
              <img
                alt="my image"
                src="icons-panne/do-not-disturb-panne-tn.png"
              /></p></B
        ></CCardHeader>
      </CCard>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    contacts: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      apiDomain: "https://apil.auto-turki.com",
      selected: this.contacts.length ? this.contacts[0] : null,
    };
  },
  methods: {
    selectContact(contact) {
      this.selected = contact;

      this.$emit("selected", contact);
    },
  },
  computed: {
    sortedContacts() {
      return _.sortBy(this.contacts, [
        (contact) => {
          if (contact == this.selected) {
            return Infinity;
          }

          return contact.unread;
        },
      ]).reverse();
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts-list {
  flex: 2;
  max-height: 100%;
  height: 600px;
  overflow: scroll;
  border-left: 1px solid #a6a6a6;

  ul {
    list-style-type: none;
    padding-left: 0;

    li {
      display: flex;
      padding: 2px;
      border-bottom: 1px solid #aaaaaa;
      height: 80px;
      position: relative;
      cursor: pointer;

      &.selected {
        background: rgb(255, 183, 68);
      }

      span.unread {
        background: #82e0a8;
        color: #fff;
        position: absolute;
        right: 11px;
        top: 20px;
        display: flex;
        font-weight: 700;
        min-width: 20px;
        justify-content: center;
        align-items: center;
        line-height: 20px;
        font-size: 12px;
        padding: 0 4px;
        border-radius: 3px;
      }

      .avatar {
        flex: 1;
        display: flex;
        align-items: center;

        img {
          width: 35px;
          border-radius: 50%;
          margin: 0 auto;
        }
      }

      .contact {
        flex: 3;
        font-size: 13px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p {
          margin: 0;

          &.name {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
